exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adStatusLabel__statusLabel___2GOXW {\n  position: absolute;\n  color: #ffffff;\n  line-height: initial;\n  left: 15px;\n  top: 15px;\n  z-index: 2;\n  min-width: 71px;\n  min-height: 20px;\n  text-align: center;\n  font-size: 12px;\n  padding: 5.5px 9px;\n  text-transform: uppercase;\n  border-radius: 2px; }\n\n.adStatusLabel__activeLabel___2BpwG {\n  background-color: #16c7a5; }\n\n.adStatusLabel__pausedLabel___2lvZs {\n  background-color: #FFFFFF;\n  color: #828282; }\n\n.adStatusLabel__soldLabel___2E2HK {\n  background-color: #a79265; }\n\n.adStatusLabel__expiredLabel___7EOqL {\n  background-color: #f94144;\n  color: #fff; }\n\n.adStatusLabel__pendingLabel___N6gxD {\n  background-color: #828282;\n  color: #fff; }\n", ""]);

// exports
exports.locals = {
	"statusLabel": "adStatusLabel__statusLabel___2GOXW",
	"activeLabel": "adStatusLabel__activeLabel___2BpwG",
	"pausedLabel": "adStatusLabel__pausedLabel___2lvZs",
	"soldLabel": "adStatusLabel__soldLabel___2E2HK",
	"expiredLabel": "adStatusLabel__expiredLabel___7EOqL",
	"pendingLabel": "adStatusLabel__pendingLabel___N6gxD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdStatusLabel/adStatusLabel.scss
// module id = 3931
// module chunks = 6